import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PrivacyPolicy() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Privacy Policy - Negotrix';
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className={`min-h-screen bg-cipher-black text-white transition-opacity duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <Header />

      <section className="pt-40 pb-24 px-6 lg:px-12 bg-cipher-dark border-b border-gray-900">
        <div className="max-w-[1000px] mx-auto">
          <h2 className="text-sm tracking-widest uppercase text-cipher-hypergreen font-bold mb-6">Legal</h2>
          <h1 className="text-[6vw] leading-[0.9] font-black tracking-tighter mb-8">
            <span className="text-white">Privacy Policy</span>
          </h1>
          <p className="text-xl text-gray-400">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </section>

      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-[1000px] mx-auto space-y-12">
          
          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">1. Introduction</h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              At Negotrix, we respect your privacy and are committed to protecting your personal data. 
              This privacy policy will inform you as to how we look after your personal data when you 
              visit our website and tell you about your privacy rights and how the law protects you.
            </p>
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">2. The Data We Collect</h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-4">
              We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-400 text-lg">
              <li><strong className="text-white">Identity Data</strong> includes first name, last name, username or similar identifier.</li>
              <li><strong className="text-white">Contact Data</strong> includes email address and telephone numbers.</li>
              <li><strong className="text-white">Technical Data</strong> includes internet protocol (IP) address, your login data, browser type and version.</li>
              <li><strong className="text-white">Usage Data</strong> includes information about how you use our website, products and services.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">3. How We Use Your Data</h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-4">
              We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-400 text-lg">
              <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
              <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
              <li>Where we need to comply with a legal obligation.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">4. Data Security</h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.
            </p>
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">5. Your Legal Rights</h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              Under certain circumstances, you have rights under data protection laws in relation to your personal data. These include the right to request access, correction, erasure, restriction, transfer, to object to processing, to portability of data and (where the lawful ground of processing is consent) to withdraw consent.
            </p>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}